import { useEffect, useState } from 'react';
import { ImageModel } from '../../../data/entities';
import { ProviderService, ImageService } from '../../../services';

interface UseMediaProps {
  providerId: number;
  onUploadSuccess?: () => void;
}

export function useMedia({ providerId, onUploadSuccess }: UseMediaProps) {
  const [previewImage, setPreviewImage] = useState<ImageModel | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  const fetchImage = async () => {
    try {
      setLoading(true);
      const provider = await new ProviderService().get(providerId);
      if (provider?.profilePictureId) {
        const image = await new ImageService().get(provider.profilePictureId);
        setPreviewImage(image);
      } else {
        setPreviewImage(null);
      }
    } catch (error) {
      console.error('Error fetching initial image:', error);
    } finally {
      setLoading(false);
    }
  };

  const uploadImage = async (image: ImageModel) => {
    const imageRequest = {
      id: providerId,
      image,
    };
    await new ProviderService().insertProfilePicture(imageRequest);
    if (onUploadSuccess) await onUploadSuccess();
  };

  const removeImage = async () => {
    await new ProviderService().deleteProfilePicture(providerId);
    setPreviewImage(null);
    if (onUploadSuccess) await onUploadSuccess();
  };

  useEffect(() => {
    fetchImage();
  }, [providerId]);

  return {
    previewImage,
    isLoading,
    uploadImage,
    removeImage,
    fetchImage,
  };
}
